//俄语

export default {
  tip: {
    fromSuccess: "Успешное представление",
  },

  login: {
    linkList: [
      { name: "Star Credits Молл ", url: "/" },
      {
        name: "Зарегистрироваться как трейдер",
        url: "https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv",
      },
    ],

    registered: {
      text: "У вас нет учетной записи? Нажмите Зарегистрироваться >>",
      url: "https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv",
    },

    shouye: {
      url: "/",
    },
    forgot: "Забыли пароль?",

    title: "Войти в аккаунт",

    email: "Почта",

    pwd: "Пароль",

    denglu: "АВТОРИЗОВАТЬСЯ",

    mima: "Забыли пароль",

    Reset: "Восстановить пароль",

    p_email: "Пожалуйста укажите почту",

    p_pwd: "Пожалуйста введите пароль",

    p_new_pwd: "Пожалуйста введите пароль",

    z_email: "Пожалуйста введите правильный адрес почты",

    long: "Длина от 6 до 18 символов",

    determine: "Определение",

    Valid:
      "Заявление на сброс пароля отправлено. Пожалуйста, проверьте свою электронную почту и проверьте ссылку сброса. Ссылка действительна в течение 24 часов!",

    Help_reset:
      "Введите зарегистрированный адрес электронной почты, и мы поможем вам сбросить пароль.",
  },

  myhead: {
    loginName: "Логин",

    Personalcenter: "Персональный центр",

    placeholder: "Пожалуйста, введите...",

    myhead_a: "На главную",

    myhead_b: "Торговля",
    myhead_bc: "Торговая платформа",

    myhead_c: "платформа",

    myhead_d: "Академия Трейдинга",

    myhead_e: "Компания ",

    myhead_f: "Interstellarfx поможет Вам",

    myhead_g: "Будь лучшим трейдером",

    myhead_h: "Начни торговать",

    myhead_i: "Попробуй демо-версию бесплатно",

    myhead_j: {
      text: "Акции компании",

      url: "https://www.interstellarfx.net/zh/trade-cashback",
    },
    myhead_k: "Возврат денег за транзакцию",

    myhead_l: "Торговые инструменты",

    myhead_m: "Связанные с торговлей",

    myhead_n: "Школа обмена иностранной валюты",

    myhead_o: "Кампания по вознаграждению за очки Фестиваля середины осени",

    myhead_p: "Уведомление InterStellar",

    myhead_q: "Прогноз рынка",

    myhead_r:
      "Будучи сложным финансовым торговым продуктом, контракты на разницу (CFD) имеют высокий риск быстрой потери из-за особенностей кредитного плеча. На счетах большинства розничных инвесторов зафиксированы потери средств в контрактах на разницу. Вам следует подумать, есть ли у вас полное представление о правилах работы контрактов на разницу и сможете ли вы нести высокий риск потери средств.",

    myhead_s: "Компания",

    myhead_t: "Рынки",

    myhead_u: "Счет",

    myhead_v: "Анализ и обучение ",

    myhead_v_a: "Анализ",

    myhead_v_b: "Обучение",

    myhead_w: "Надзор",

    myhead_x: "Страхование",

    myhead_y: "Соблюдения правовых норм",

    myhead_z: "Последние новости",

    myhead_aa: "Торговое руководство",

    myhead_bb: "Азбука торговых терминов",

    myhead_cc: "Мгновенные новости",

    myhead_dd: "анализ транзакций",

    myhead_ee: "Форекс инвестиции",

    myhead_ff: "Спонсорство & Социальная ответственность",

    myhead_gg: "ISG Webinar",

    myhead_hh: "FISG Анализ",

    myhead_ii: "Курс трейдинга",
    myhead_com: "Конкурс демо-трейдинга InterStellar Group",
  },

  Home: {
    Home_a: "Star Points Молл ",

    Home_b: "Обмен баллов на подарки!",

    Home_c:
      "На торговые баллы можно приобрести хорошие подарки, модную цифровую технику, изысканные электроприборы, роскошные автомобили и множество других хороших вещей, которые можно забрать домой в любое время... ",

    Home_d: "Посмотреть действующие условия и правила подачи ",

    Home_e: "Нажми",

    Home_f: "сюда",

    Home_g: "Хороший подарок ждет тебя ",

    Home_h: "Нет подарка, который ты хочешь?",

    Home_i:
      "Вы можете в любое время порекомендовать нам интересующие вас товары, мы дополним товары в зависимости от популярности рекомендуемого подарка...",

    Home_j: "Бренд подарка",

    Home_k: "Описание товара",

    Home_l: "Подать",

    Home_m: "Бонусные баллы Правила обмена подарков",

    Home_n: "Как получить баллы ",

    Home_o:
      "Любой клиент FISG, который торговал валютными парами, драгоценными металлами и энергетическими продуктами на нашей платформе, получит 1 балл  за каждую сделку. ",

    Home_p: "Как обменять подарок? ",

    Home_q:
      "Подайте заявку на обмен в торговом центре баллов (укажите свое имя, контактную информацию, номер торгового счета и другую информацию), и ответственный департамент проверит ваши баллы и наличие каких-либо недавних незаконных транзакций, а также распределит их после прохождения проверки.  ",

    Home_r: "Время доставки подарков",

    Home_s:
      "Подарок будет доставлен в течение 15 дней после одобрения заявки на обмен. Обратите внимание, что для проверки вы также можете связаться со своим менеджером по работе с клиентами, чтобы проверить ход доставки.",

    Home_t: "Инструкции после приобритения",

    Home_u:
      "Все товары, представленные в интегральном торговом центре, предоставляются сторонними поставщиками, и необоснованный возврат не допускается. Однако, если в процессе экспресс-доставки обнаружен неправильный подарок или он поврежден, вы можете обратиться в эксклюзивную службу поддержки клиентов, чтобы решить проблему.",

    Home_v: "популярные рекомендации",

    Home_w: "Здесь вас ждут самые популярные трендовые товары",

    Home_x: "Конвертировать",

    Home_y: "Баллы",

    Home_z: "Выбрать бренд",

    Home_aa: "Новый ассортимент продукции ",

    Home_bb: "Сортировка баллов",

    Home_cc: "Выберите бренды",

    Home_dd: "Всего за",

    Home_ee: "обмениваемых баллов",

    Home_ff: "Пожалуйста,укажите бренд подарка ",

    Home_gg: "Пожалуйста, введите описание продукта ",

    Home_hh: "Успешно",

    Home_hh: "Условия",

    Home_ii: "Успешно",

    Home_zz: "Интеграл Молл",

    Home_kk: "POINTS МOлл",
    Home_search: "Искать товары",
    seckill: "флеш-сale",
    daySeckill: "Время ежедневного флеш-сэла",
    cutDownTips: "Слепой ящик флеш-продажаカ운tdown",
    cutDownTips1: "Слепой ящик флеш-продажа окончена",
    cutDownTips2: "Слепой ящик флеш-продажа вне времени",
    cutDownTips3: "Событие не началось",
  },

  detail: {
    detail_a: "Вернуться на главную страницу Молла",

    detail_b: "Модели",

    detail_c: "Число",

    detail_d: "Инструкция по обмену подарками",

    detail_e:
      "Подарок будет доставлен в течение 15 дней после одобрения заявки на обмен. Обратите внимание, что для проверки вы также можете связаться со своим специальным менеджером по работе с клиентами, чтобы проверить ход доставки.",

    detail_f:
      "Все товары, представленные в торговом центре Integrpoint, предоставляются сторонним поставщиком, возврат без причины не поддерживается. Однако, если в процессе экспресс-доставки обнаружен неправильный подарок или повреждение, вы можете обратиться в эксклюзивную службу поддержки клиентов, чтобы решить проблему.. ",

    detail_g: "Детали продукта ",

    detail_h: "Популярные рекомендации",

    detail_i: "Пожалуйста войдите",

    address_s: "Адрес нового сбора",
  },

  settlement: {
    balance: "Баланс баллов ",

    settlement_a: "Информация о заказе ",

    settlement_b: "Имя",

    settlement_c: "Спецификация",

    settlement_d: "Цена за единицу",

    settlement_e: "Количество",

    settlement_f: "Информация о грузополучателе ",

    settlement_g: "Добавьте адрес ",

    settlement_h: "Сумма расчета ",

    settlement_i: "Баллы",

    settlement_z: "Рассчитаться сейчас",

    settlement_k: "Совершено успешно",

    settlement_l: "Пожалуйста, подтвердите свой заказ!",

    settlement_m: "Продукт",

    settlement_n: "Информация о продукте",

    settlement_o: "Информация о баллах!",

    settlement_p: "На данный момент требуемых баллов недостаточно.",

    settlement_title: "Успешно!",

    settlement_tip:
      "Ваш заказ на обмен будет доставлен в течение 15 рабочих дней. Вы также можете связаться со своим менеджером по обслуживанию клиентов, чтобы проверить ход доставки.",

    settlement_button: "Определять",
    settlement_button_err: "Определять",

    settlement_tip_error:
      "Способ получения баллов: Торгуя валютными парами, драгоценными металлами и энергоносителями, вы можете заработать 1 балл за каждую транзакцию (заказы с позицией более трех минут считаются действительными)",
  },

  meber: {
    meber_a: "Центр ордеров",

    meber_b: "Персональный центр",

    meber_c: "Мои ордера ",

    meber_d: "Управление адресами",

    meber_e: "Выйти ",
  },

  address: {
    address_a: "Увеличить",

    address_b: "Имя",

    address_c: "Звонок",

    address_d: "Адрес",

    address_e: "Действие",

    address_f: "Редактирование",

    address_g: "Удалить",

    address_h: "Пожалуйста выберите",

    address_i: "Детали адреса  ",

    address_j: "Сохранить",

    address_k: "Введите свое имя ",

    address_l: "Пожалуйста укажите свой номер ",

    address_m: "Неверный формат номера телефона",

    address_n: "Пожалуйста укажите свой номер ",

    address_o: "Пожалуйста, введите полный адрес ",

    address_p: "Изменено успешно",

    address_q: "Добавлено успешно",

    address_r: "Удалено успешно",

    address_s: "Новый адрес для сбора",

    address_t: "Вы не добавили адрес получения",
  },

  order: {
    order_a: "Мой ордер ",

    order_b: "Дата",

    order_c: "Номер ордера ",

    order_d: "Получатель",

    order_e: "Сумма",

    order_f: "Детали ордера ",

    order_g: "Звонок",

    order_h: "Адрес",

    order_i: "Состояние",

    order_j: "Способ доставки",

    order_k: "Действие",

    order_l: "Закрыто ",

    order_m: "Создано",

    order_n: "Оплачено ",

    order_o: "Возрат в процессе ",

    order_p: "Возращено ",

    order_q: "Доставлено ",

    order_r: "Закончено ",

    order_s: "Стоимость Интеграл ",
  },

  userinfo: {
    userinfo_a: "Персональный центр",

    userinfo_b: "Время последнего изменения ",

    userinfo_c: "Почта пользователя ",

    userinfo_d: "Доступные баллы ",
  },

  orderDetail: {
    orderDetail_a: "Потвердить заказ ",

    orderDetail_b: "Оплата успешна ",

    orderDetail_c: "Товар отсутствует",

    orderDetail_d: "Ожидание доставки",

    orderDetail_e: "Завершено",

    orderDetail_f: "Метод оплаты ",

    orderDetail_g: "Имя курьера",

    orderDetail_h: "Идентификационный номер",
  },

  footerbox: {
    footerbox_b: "Современный глобальный рынок",
    footerbox_c: "ПОПРОБУЙТЕ БЕСПЛАТНУЮ ДЕМО-ВЕРСИЮ",

    footerbox_d:
      "Служба поддержки клиентов Азиатско-Тихоокеанского региона (Сингапур)",

    footerbox_e: "Электронная почта компании",

    footerbox_f: "support@interstellarsfx.com",

    footerbox_g: "НАЧАТЬ ТОРГОВАТЬ",

    footerbox_h: "Форекс",

    footerbox_i: "Драгоценными металлами",
    footerbox_ik: "Акции",

    footerbox_j: "Природные ресурсы",

    footerbox_k: "Индексы",

    footerbox_a: "О трейдинге",

    footerbox_l: "Счет",

    footerbox_m: "Типы счетов",
    footerbox_ml: "Политика использования кредитного плеча",

    footerbox_n: "Депозит и вывод средств",

    footerbox_o: "Начните торговлю",

    footerbox_p: "Попробуйте бесплатную демо-версию",

    footerbox_q: "Торговые инструменты",

    footerbox_r: "MetaTrader 4",

    footerbox_s: "MAM",

    footerbox_t: "MultiTerminal",

    footerbox_u: "Экономический календарь",

    footerbox_v: "Калькулятор Форекс",

    footerbox_w: "VPS",

    footerbox_x: "Trading Central",

    footerbox_y: "Академия трейдинга",

    footerbox_z: "Срок собрания",

    footerbox_aa: "О InterStellar",
    footerbox_ad: "О нас",

    footerbox_bb: "Новости",

    footerbox_cc: "Карьера",

    footerbox_dd: "Свяжитесь с нами",

    footerbox_ee: "Партнерство",

    footerbox_ff: "Часто задаваемые вопросы",

    footerbox_mm: "Отказ от ответственности:",

    footerbox_nn: `Веб-сайт www.interstellarsfx.com управляется компанией First Interstellar Global Ltd, компанией с ограниченной ответственностью, зарегистрированной в соответствии с законодательством Сейшельских Островов, с регистрационным номером [вставьте регистрационный номер компании] и адресом зарегистрированного офиса по адресу Room 9, Deenu's Building, Providence, Mahe. , Сейшельские острова. Компания First Interstellar Global Ltd авторизована и регулируется Управлением финансовых услуг Сейшельских островов с лицензией №. СД127. First Interstellar Global Ltd не входит в европейскую систему финансового регулирования. Директива о рынках финансовых инструментов (MiFID) II, а также любое другое европейское регулирование финансовых услуг не применимо к предоставлению финансовых услуг компанией First Interstellar Global Ltd. Кроме того, не существует положения о схеме компенсации инвесторам. Отказ от ответственности. : Веб-сайт www.interstellarsfx.com управляется компанией First Interstellar Global Ltd, компанией с ограниченной ответственностью, зарегистрированной в соответствии с законодательством Сейшельских Островов, с регистрационным номером [вставить регистрационный номер компании] и адресом зарегистрированного офиса по адресу Room 9, Deenu's Building, Providence, Маэ, Сейшельские острова. Компания First Interstellar Global Ltd авторизована и регулируется Управлением финансовых услуг Сейшельских островов с лицензией №. СД127. First Interstellar Global Ltd не входит в европейскую систему финансового регулирования. Директива о рынках финансовых инструментов (MiFID) II, а также любое другое европейское регулирование финансовых услуг не применимо к предоставлению финансовых услуг компанией First Interstellar Global Ltd. Кроме того, не существует положения о схеме вознаграждения инвесторов.`,

    footerbox_gg:
      "InterstellarFX не предлагает CFD резидентам определенных юрисдикций, включая США, Иран, Канаду, Бельгию и Францию.",

    footerbox_hh: "Предупреждение о риске:",

    footerbox_ii: `Торговля иностранной валютой и финансовыми продуктами с использованием заемных средств сопряжена с высокими рисками и может привести к потере основной суммы. Вам не следует рисковать потерями больше, чем вы можете себе позволить, и убедитесь, что вы полностью понимаете связанные с этим риски. Торговля продуктами с кредитным плечом подходит не всем инвесторам. Торговля продуктами без кредитного плеча, такими как акции, также сопряжена с риском, поскольку стоимость акций может как снижаться, так и повышаться, а это означает, что вы можете вернуть меньше денег, чем первоначально вложили. Прошлые результаты не являются гарантией будущих результатов. Прежде чем торговать, пожалуйста, оцените свой уровень опыта, инвестиционные цели и при необходимости обратитесь за независимой финансовой консультацией. Клиент несет ответственность за то, чтобы юридические требования страны его проживания позволяли ему использовать услуги, предоставляемые брендом StarWorld.`,
    footerbox_zz: "Заявление о рисках",

    footerbox_kk: "политика конфиденциальности",

    footerbox_ll: "© 2021 FISG. Все права защищены.",
  },
  other: {
    sections: {
      about: "О КОМПАНИИ FISG",
      trading: "Торговля",
      campaigns: "Кампании",
      education: "Обучение",
      markets: "Рынки",
    },
    about: {
      title: "First InterStellar Group",
      aboutFISG: "О КОМПАНИИ FISG",
      legalCompliance: "Юридическое соответствие",
      clientReviews: "Отзывы клиентов",
      insurance: "Страхование",
      events: "События InterStellar",
      partnership: "Партнерство",
    },
    trading: {
      platformTitle: "Торговая платформа",
      mt4: "MetaTrader 4",
      mt5: "MetaTrader 5",
      webTerminal: "MetaTrader WebTerminal",
      copyTrade: "Copy Trade",
      app: "FISG APP",
      marketsTitle: "Рынки для торговли",
      forex: "Forex",
      metals: "Металлы",
      energy: "Энергия",
      index: "Индексы",
      stock: "Акции",
      cryptocurrency: "Криптовалюта",
      accountTitle: "Счет",
      accountTypes: "Типы счетов",
      leverage: "Политика кредитного плеча",
      depositWithdrawal: "Депозит и вывод средств",
      toolsTitle: "Торговые инструменты",
      mam: "MAM",
      pamm: "PAMM",
      multiTerminal: "MultiTerminal",
      calculator: "Forex калькулятор",
    },
    campaigns: { title: "Кампании" },
    education: {
      title: "Обучение",
      seminar: "Семинар",
      whatIsForex: "Что такое торговля Forex?",
      course: "Торговый курс",
      investment: "Инвестиции в Forex",
      glossary: "Глоссарий торговых терминов",
      faq: "Часто задаваемые вопросы",
    },
    markets: {
      title: "Рынки",
      notices: "Уведомления FISG",
      analysis: "Анализ FISG",
      calendar: "Экономический календарь",
      transaction: "Анализ транзакций",
      news: "Последние новости",
      times: "FISG Times",
      marketWrap: "Market Wrap",
    },
    ctaTradeNow: "ТОРГОВАТЬ СЕЙЧАС",
    login: "Вход",

    topTips1: "1 балл равен 1 стандартному лоту или 100-центовому лоту.",
    topTips2: " Межрегиональное погашение не поддерживается.",
    topTips3:
      "Я подтверждаю, что объём моей транзакции соответствует количеству баллов, отображаемому системой, и баллы были успешно погашены.",
    topTips4:
      "Я понимаю, что погашение будет аннулировано, если системная ошибка приведет к некорректному отображению баллов транзакции.",
    remark: "Примечание",

    confirmAddress: "Подтвердить адрес",
    cancel_btn: "Отмена",

    setAsDefault: "Установить по умолчанию",
    exchangeAccount: "Обменный аккаунт",

    defaultAddress: "По умолчанию",

    exchangeAccount1: "Выбрать торговый аккаунт",

    exchangeAccount2: "Выберите торговый аккаунт для получения денежного приза",
  },
}
